// export const createValidator = (schema, context = {}) => (formData) => {
//   const errors = {};
//   const messageTransformer = context.messageTransformer || ((msg) => msg); // defaults to identity

//   Object.entries(schema).forEach(([field, rules]) => {
//     const value = formData?.hasOwnProperty(field) ? formData[field] : "";
//     const fieldErrors = [];

//     rules.forEach((rule) => {
//       if (!rule.validator(value, formData)) {
//         const transformedMessage = messageTransformer(rule.message);
//         fieldErrors.push(transformedMessage);
//       }
//     });

//     if (fieldErrors.length > 0) {
//       errors[field] = fieldErrors;
//     }
//   });

//   return Object.keys(errors).length > 0 ? errors : null;
// };

export const validationRules = {
  required: (message) => ({
    validator: (value) => value !== null && value !== undefined && Boolean(value?.toString().trim()) && value.toString().trim() !== "None",
    message,
  }),
  // Empty values are left to `required` so the two rules cannot report the same
  // field twice.
  oneOf: (allowedValues, message) => ({
    validator: (value) => !value?.toString().trim() || allowedValues.includes(value),
    message,
  }),
  numeric: (message) => ({
    validator: (value) => !isNaN(parseFloat(value)) && isFinite(value),
    message,
  }),
  minLength: (length, message) => ({
    validator: (value) => value?.toString().length >= length,
    message,
  }),
  maxLength: (length, message) => ({
    validator: (value) => value?.toString().length <= length,
    message,
  }),
  equals: (compareField, message) => ({
    validator: (value, formData) => value === formData[compareField],
    message,
  }),
  inRange: (min, max, message) => ({
    validator: (value) => {
      const num = parseFloat(value);
      return num >= min && num <= max;
    },
    message,
  }),
  isBoolean: (message) => ({
    validator: (value) => typeof value === "boolean",
    message,
  }),
  notEmpty: (message) => ({
    validator: (value) =>
      value !== null && value !== undefined && value.toString().trim() !== "",
    message,
  }),
  dateAfter: (dateField, message) => ({
    validator: (value, formData) =>
      new Date(value) > new Date(formData[dateField]),
    message,
  }),
  atLeastOneValueNotEmpty: (message) => ({
    validator: (value) =>
      Array.isArray(value) && value.some((item) => item !== null && item !== undefined && item.toString().trim() !== ""),
      message,
  })
};


export const createValidator = (schema, context = {}) => (formData) => {
  const errors = {};
  const messageTransformer = context.messageTransformer || ((msg) => msg);

  Object.entries(schema).forEach(([field, rules]) => {
    const value = formData?.hasOwnProperty(field) ? formData[field] : "";
    const fieldErrors = [];

    rules.forEach((rule) => {
      // 🔍 If rule is a function (conditional), execute it with full formData
      if (typeof rule === "function") {
        rule = rule(formData); // should return a rule object or null
      }

      if (rule && typeof rule.validator === "function") {
        const isValid = rule.validator(value, formData);
        if (!isValid) {
          const transformedMessage = messageTransformer(rule.message);
          fieldErrors.push(transformedMessage);
        }
      }
    });

    if (fieldErrors.length > 0) {
      errors[field] = fieldErrors;
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
};
